/* ==========================================================================
   Sprintbahn-Anfrage — Konfiguration aus der URL ins Formular
   --------------------------------------------------------------------------
   Geladen von: sections/ceq-sprintbahn-anfrage.liquid (defer).

   Der Konfigurator auf der Planer-Seite haengt Maschinen-Werte an den Link
   (Typ-Schluessel, Farb-ID, Masse, Richtpreis). Diese Seite beschriftet sie
   in ihrer eigenen Sprache — dadurch zeigt die EN-Seite EN-Labels, auch
   wenn der Link von der DE-Seite kam.

   Aus den Zeilen entstehen zwei Dinge: die sichtbare Zusammenfassung und
   die versteckten `contact[…]`-Felder, die als Zeilen in der Mail landen.
   ========================================================================== */

(function () {
  'use strict';

  function fmtNum(v, maxFrac) {
    var n = parseFloat(v);
    if (!isFinite(n)) return null;
    return n.toLocaleString('de-CH', { minimumFractionDigits: 0, maximumFractionDigits: maxFrac });
  }

  /* Der Total kann bei halben Metern auf 50 Rappen genau sein. */
  function fmtChf(v) {
    var n = parseFloat(v);
    if (!isFinite(n)) return null;
    var whole = Math.abs(n % 1) < 0.005;
    return n.toLocaleString('de-CH', {
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2
    });
  }

  function build(root) {
    var i18n;
    try {
      i18n = JSON.parse(root.querySelector('[data-sbp-inquiry-i18n]').textContent);
    } catch (e) {
      return;
    }

    var q = new URLSearchParams(window.location.search);
    var summary = root.querySelector('[data-sbp="summary"]');
    var empty = root.querySelector('[data-sbp="summary-empty"]');
    var hidden = root.querySelector('[data-sbp="hidden-fields"]');
    var noConfig = root.querySelector('[data-sbp="no-config"]');

    /* Zwei Dezimalen, seit die Laenge im Planer frei eingebbar ist — 13,75 m
       muss auch in der Mail als 13,75 m stehen. */
    var len = fmtNum(q.get('l'), 2);
    var width = fmtNum(q.get('w'), 2);

    /* Ohne Masse in der URL ist jemand direkt hier gelandet. */
    if (!len || !width) {
      if (noConfig) noConfig.removeAttribute('hidden');
      return;
    }

    var nRaw = parseInt(q.get('n'), 10);
    var area = fmtNum(parseFloat(q.get('l')) * parseFloat(q.get('w')) * (isFinite(nRaw) && nRaw > 0 ? nRaw : 1), 2);
    var widthTxt = width + ' m';
    if (q.get('wm') === 'other') widthTxt += ' (' + i18n.customWidth + ')';

    /* Elemente kommen als zwei parallele Listen: `el` die IDs, `elp` die
       Positionen in derselben Reihenfolge. Fehlt `elp`, bleibt es beim Namen. */
    var elementIds = (q.get('el') || '').split(',').filter(Boolean);
    var elementPos = (q.get('elp') || '').split(',');
    var elementTxt = elementIds.length
      ? elementIds.map(function (id, i) {
          var name = i18n.elements[id] || id;
          var pos = fmtNum(elementPos[i], 1);
          return pos === null ? name : name + ' @ ' + pos + ' m';
        }).join(', ')
      : i18n.none;

    var count = parseInt(q.get('n'), 10);
    if (!isFinite(count) || count < 1) count = 1;

    var total = fmtChf(q.get('tot'));

    /* Die Unterlage kommt nur mit, wenn sie im Konfigurator angehakt war.
       Ohne diese Zeile stuende sie zwar im Richtpreis, aber in keiner Zeile
       der Mail -- die Offerte wuerde die Platten dann wieder vergessen. */
    var ecoTxt = null;
    if (q.get('eco') === '1') {
      var ecoQ = parseInt(q.get('ecoq'), 10);
      var ecoChf = fmtChf(q.get('ecochf'));
      if (isFinite(ecoQ) && ecoQ > 0) {
        ecoTxt = i18n.underlayValue
          .replace('{{platten}}', String(ecoQ))
          .replace('{{chf}}', ecoChf || '—');
      }
    }

    var rows = [
      ['type', i18n.types[q.get('t')] || q.get('t') || ''],
      ['length', len + ' m'],
      ['width', widthTxt],
      ['count', String(count)],
      ['area', area + ' m²'],
      ['color', i18n.colors[q.get('c')] || q.get('c') || ''],
      ['markingColor', q.get('mc') ? (i18n.colors[q.get('mc')] || q.get('mc')) : null],
      ['endText', q.get('txt') === null ? null : (q.get('txt') === '1' ? i18n.yes : i18n.no)],
      ['logo', q.get('logo') === '1' ? i18n.yes : i18n.no],
      ['elements', elementTxt],
      ['tape', i18n.tapeIncluded],
      ['underlay', ecoTxt],
      ['total', total ? 'CHF ' + total : '']
    ];

    rows = rows.filter(function (r) { return r[1] !== null && r[1] !== ''; });

    if (summary) {
      summary.innerHTML = '';
      rows.forEach(function (r) {
        var wrap = document.createElement('div');
        var dt = document.createElement('dt');
        dt.textContent = i18n.rows[r[0]] || r[0];
        var dd = document.createElement('dd');
        dd.textContent = r[1];
        wrap.appendChild(dt);
        wrap.appendChild(dd);
        summary.appendChild(wrap);
      });
      summary.removeAttribute('hidden');
    }
    if (empty) empty.setAttribute('hidden', '');

    if (hidden) {
      hidden.innerHTML = '';
      var add = function (label, value) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'contact[' + label + ']';
        input.value = value;
        hidden.appendChild(input);
      };
      rows.forEach(function (r) { add(i18n.rows[r[0]] || r[0], r[1]); });

      /* Sprinttracks-Artikelcode fuer die Bestellung, nicht fuer den Kunden. */
      if (q.get('code')) add('Sprinttracks-Code', q.get('code'));
    }

    /* „Konfiguration aendern" fuehrt zurueck zum richtigen Konfigurator. */
    var change = root.querySelector('[data-sbp="change"]');
    if (change && q.get('t')) {
      var anchors = {
        unlined: 'sprintbahn-ohne-linien',
        start_finish: 'sprintbahn-start-ziel',
        numbered: 'sprintbahn-metermarkierung',
        hybrid: 'sprintbahn-hybrid'
      };
      var anchor = anchors[q.get('t')];
      if (anchor) change.href = change.getAttribute('href') + '#' + anchor;
    }
  }

  /* ---- GA4 ---------------------------------------------------------------
     Zwei Schritte, weil Shopify das Kontaktformular per Reload verarbeitet:
     beim Absenden wird die Konfiguration in den sessionStorage gelegt, nach
     dem Reload feuert der Erfolgsfall das Event. Ueber die URL geht es nicht —
     ob Shopify die Query-Parameter durch den Redirect traegt, ist nicht
     zugesichert. Kommt nichts aus dem Storage (anderer Tab, Storage gesperrt),
     wird das Event trotzdem gemeldet, dann eben ohne Konfiguration.
     ---------------------------------------------------------------------- */
  var STORE_KEY = 'ceq_turf_inquiry';

  /* Einmal pro Seitenaufruf. `init()` laeuft im Theme-Editor bei jedem
     Neuladen der Section erneut — ohne diese Sperre zaehlte GA4 dieselbe
     Anfrage mehrfach als Conversion. Am Dev-Server nachgestellt und gemessen. */
  var submitTracked = false;

  function paramsFromQuery() {
    var q = new URLSearchParams(window.location.search);
    if (!q.get('t')) return null;

    var p = {
      turf_type: q.get('t'),
      type_code: q.get('code') || '',
      length_m: parseFloat(q.get('l')) || null,
      width_m: parseFloat(q.get('w')) || null,
      track_color: q.get('c') || '',
      has_logo: q.get('logo') === '1' ? 1 : 0,
      element_count: q.get('el') ? q.get('el').split(',').length : 0,
      quantity: parseInt(q.get('n'), 10) || 1,
      value: parseFloat(q.get('tot')) || null,
      currency: 'CHF'
    };
    if (q.get('mc')) p.marking_color = q.get('mc');
    if (q.get('txt')) p.has_end_text = q.get('txt') === '1' ? 1 : 0;
    return p;
  }

  function trackInquiry(root) {
    var form = root.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        var p = paramsFromQuery();
        if (!p) return;
        try {
          window.sessionStorage.setItem(STORE_KEY, JSON.stringify(p));
        } catch (e) {
          /* Storage gesperrt — das Event kommt dann ohne Konfiguration. */
        }
      });
    }

    if (submitTracked) return;
    if (!root.querySelector('[data-sbp-posted]')) return;
    if (typeof window.ceqTurfTrack !== 'function') return;
    submitTracked = true;

    var stored = null;
    try {
      stored = JSON.parse(window.sessionStorage.getItem(STORE_KEY) || 'null');
      window.sessionStorage.removeItem(STORE_KEY);
    } catch (e) {
      stored = null;
    }

    window.ceqTurfTrack('turf_inquiry_submit', stored || paramsFromQuery() || { currency: 'CHF' });
  }

  function init(scope) {
    var root = (scope || document).querySelector('[data-sbp-inquiry]');
    if (root) {
      build(root);
      trackInquiry(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-sbp-inquiry]')) init(event.target);
  });
})();
